module.exports = __webpack_public_path__ + "media/images/lp_v6_mv_pict01_pc01-edea08e2bda78e656732a9b8bff7bbea.png";